import Highcharts from 'highcharts';
import { buildFillColor, ColorDescription, ColorDescriptionType } from 'components/HighchartsWrapper';

export function buildSeriesColor(settings: ColorDescription): {
	color: Highcharts.ColorType;
	fillColor: Highcharts.ColorType;
} {
	const gradientColor = buildFillColor({
		enabled: settings?.type === ColorDescriptionType.Gradient,
		direction: settings?.direction,
		startColor: settings?.startColor,
		finishColor: settings?.finishColor,
	});

	const color = gradientColor ?? settings?.startColor;
	return { color, fillColor: color };
}
